// App-wide constants

export const MAX_VIDEO_DURATION = 300; // 5 minutes in seconds
export const RECOMMENDED_VIDEO_DURATION = 60; // 1 minute in seconds

export const IDLE_TIMEOUT = 5000; // 5 seconds to return to attractor
export const INACTIVITY_TIMEOUT = 300000; // 5 minutes to reset kiosk

export const EVENT_TYPES = [
  { value: 'Wedding', label: 'Wedding' },
  { value: 'Corporate', label: 'Corporate Event' },
  { value: 'Birthday', label: 'Birthday Party' },
];

export const VIDEO_CONSTRAINTS = {
  video: {
    facingMode: 'user',
    width: { ideal: 1920 },
    height: { ideal: 1080 }, // 16:9 horizontal (landscape)
    frameRate: { ideal: 30 },
  },
  audio: {
    echoCancellation: true,
    noiseSuppression: true,
    sampleRate: 48000,
  },
};

// Supported MIME types in order of preference
export const SUPPORTED_MIME_TYPES = [
  'video/webm;codecs=vp9,opus',
  'video/webm;codecs=vp8,opus',
  'video/webm',
  'video/mp4', // iOS Safari fallback
];

export const ROUTES = {
  ADMIN_LOGIN: '/admin/login',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_EVENT_DETAIL: '/admin/events/:eventId',
  KIOSK: '/kiosk/:eventId',
  GUEST_GALLERY: '/gallery/:eventId',
};
